/**
 * @generated SignedSource<<72dd30c50305f2dd507b5fb3b550a6ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemPlusNewsAgendaItemTopic$data = {
  readonly entityId: string;
  readonly name: string;
  readonly newsAgenda: {
    readonly secondaryDescription: string | null | undefined;
    readonly startDate: number | null | undefined;
  } | null | undefined;
  readonly updatedDate: number | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksNewsAgendaTopic">;
  readonly " $fragmentType": "itemPlusNewsAgendaItemTopic";
};
export type itemPlusNewsAgendaItemTopic$key = {
  readonly " $data"?: itemPlusNewsAgendaItemTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemPlusNewsAgendaItemTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemPlusNewsAgendaItemTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NewsAgenda",
      "kind": "LinkedField",
      "name": "newsAgenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksNewsAgendaTopic"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "3071b503715410aa0c5a820984652674";

export default node;
